import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import Feed from "@/pages/Feed";
import { Button } from "@/components/ui/button";

export default function GroupDetail() {
  const { id } = useParams();
  const [g, setG] = useState(null);

  const load = async () => { const { data } = await api.get(`/groups/${id}`); setG(data); };
  useEffect(() => { load(); }, [id]);

  const toggle = async () => { await api.post(`/groups/${id}/join`); load(); };

  if (!g) return <div className="max-w-3xl mx-auto px-6 py-20 text-slate-500">Loading…</div>;

  return (
    <div data-testid="group-detail-page">
      <div className="bg-[#0A192F] text-[#FDFBF7]">
        <div className="max-w-3xl mx-auto px-6 py-12">
          <div className="label-eyebrow text-[#C5A059]">Group</div>
          <h1 className="mt-2 font-display text-4xl sm:text-5xl">{g.name}</h1>
          <p className="mt-3 text-slate-300 max-w-2xl">{g.description}</p>
          <div className="mt-6 flex items-center gap-3">
            <div className="text-sm text-slate-300">{g.members_count} members</div>
            <Button onClick={toggle} className={g.is_member ? "bg-white/10 text-white hover:bg-white/20" : "bg-[#C5A059] text-[#0A192F] hover:bg-[#B38F48]"} data-testid="group-join-button">
              {g.is_member ? "Leave group" : "Join group"}
            </Button>
          </div>
        </div>
      </div>
      <Feed groupId={id} />
    </div>
  );
}
